import { z } from 'zod';

import { introspection_types } from '~/bigcommerce-graphql';

export const legacyCurrencyCodeMap: Record<CurrencyCode, number> = {
  ADP: 0,
  AED: 1,
  AFA: 0,
  AFN: 0,
  ALK: 0,
  ALL: 0,
  AMD: 0,
  ANG: 0,
  AOA: 0,
  AOK: 0,
  AON: 0,
  AOR: 0,
  ARA: 0,
  ARL: 0,
  ARM: 0,
  ARP: 0,
  ARS: 2,
  ATS: 0,
  AUD: 3,
  AWG: 65,
  AZM: 0,
  AZN: 0,
  BAD: 0,
  BAM: 66,
  BAN: 0,
  BBD: 4,
  BDT: 67,
  BEC: 0,
  BEF: 0,
  BEL: 0,
  BGL: 0,
  BGM: 0,
  BGN: 68,
  BGO: 0,
  BHD: 5,
  BIF: 0,
  BMD: 69,
  BND: 0,
  BOB: 6,
  BOL: 0,
  BOP: 0,
  BOV: 0,
  BRB: 0,
  BRC: 0,
  BRE: 0,
  BRL: 7,
  BRN: 0,
  BRR: 0,
  BRZ: 0,
  BSD: 70,
  BTN: 0,
  BUK: 0,
  BWP: 0,
  BYB: 0,
  BYN: 0,
  BYR: 0,
  BZD: 0,
  CAD: 8,
  CDF: 0,
  CHE: 0,
  CHF: 9,
  CHW: 0,
  CLE: 0,
  CLF: 0,
  CLP: 10,
  CNX: 0,
  CNY: 11,
  COP: 12,
  COU: 0,
  CRC: 0,
  CSD: 0,
  CSK: 0,
  CUC: 0,
  CUP: 0,
  CVE: 0,
  CYP: 0,
  CZK: 13,
  DDM: 0,
  DEM: 0,
  DJF: 0,
  DKK: 14,
  DOP: 92,
  DZD: 0,
  ECS: 0,
  ECV: 0,
  EEK: 0,
  EGP: 15,
  ERN: 0,
  ESA: 0,
  ESB: 0,
  ESP: 0,
  ETB: 0,
  EUR: 16,
  FIM: 0,
  FJD: 71,
  FKP: 0,
  FRF: 0,
  GBP: 72,
  GEK: 0,
  GEL: 0,
  GHC: 0,
  GHS: 73,
  GIP: 0,
  GMD: 74,
  GNF: 0,
  GNS: 0,
  GQE: 0,
  GRD: 0,
  GTQ: 75,
  GWE: 0,
  GWP: 0,
  GYD: 0,
  HKD: 17,
  HNL: 0,
  HRD: 0,
  HRK: 76,
  HTG: 0,
  HUF: 18,
  IDR: 19,
  IEP: 0,
  ILP: 0,
  ILR: 0,
  ILS: 20,
  INR: 21,
  IQD: 0,
  IRR: 94,
  ISJ: 0,
  ISK: 22,
  ITL: 0,
  JMD: 23,
  JOD: 24,
  JPY: 25,
  KES: 26,
  KGS: 0,
  KHR: 77,
  KMF: 0,
  KPW: 0,
  KRH: 0,
  KRO: 0,
  KRW: 27,
  KWD: 28,
  KYD: 0,
  KZT: 0,
  LAK: 78,
  LBP: 29,
  LKR: 30,
  LRD: 0,
  LSL: 0,
  LTL: 31,
  LTT: 0,
  LUC: 0,
  LUF: 0,
  LUL: 0,
  LVL: 32,
  LVR: 0,
  LYD: 0,
  MAD: 33,
  MAF: 0,
  MCF: 0,
  MDC: 0,
  MDL: 79,
  MGA: 80,
  MGF: 0,
  MKD: 81,
  MKN: 0,
  MLF: 0,
  MMK: 0,
  MNT: 0,
  MOP: 0,
  MRO: 0,
  MTL: 0,
  MTP: 0,
  MUR: 82,
  MVP: 0,
  MVR: 83,
  MWK: 0,
  MXN: 34,
  MXP: 0,
  MXV: 0,
  MYR: 35,
  MZE: 0,
  MZM: 0,
  MZN: 0,
  NAD: 36,
  NGN: 37,
  NIC: 0,
  NIO: 0,
  NLG: 0,
  NOK: 38,
  NPR: 39,
  NZD: 40,
  OMR: 41,
  PAB: 42,
  PEI: 0,
  PEN: 43,
  PES: 0,
  PGK: 0,
  PHP: 44,
  PKR: 45,
  PLN: 46,
  PLZ: 0,
  PTE: 0,
  PYG: 84,
  QAR: 47,
  RHD: 0,
  ROL: 0,
  RON: 48,
  RSD: 85,
  RUB: 49,
  RUR: 0,
  RWF: 0,
  SAR: 50,
  SBD: 0,
  SCR: 86,
  SDD: 0,
  SDG: 0,
  SDP: 0,
  SEK: 51,
  SGD: 52,
  SHP: 0,
  SIT: 0,
  SKK: 0,
  SLL: 0,
  SOS: 0,
  SRD: 0,
  SRG: 0,
  SSP: 0,
  STD: 0,
  SUR: 0,
  SVC: 0,
  SYP: 87,
  SZL: 0,
  THB: 53,
  TJR: 0,
  TJS: 0,
  TMM: 0,
  TMT: 0,
  TND: 88,
  TOP: 0,
  TPE: 0,
  TRL: 0,
  TRY: 54,
  TTD: 0,
  TWD: 55,
  TZS: 0,
  UAH: 56,
  UAK: 0,
  UGS: 0,
  UGX: 89,
  USD: 57,
  USN: 0,
  USS: 0,
  UYI: 0,
  UYP: 0,
  UYU: 58,
  UZS: 0,
  VEB: 0,
  VEF: 59,
  VND: 60,
  VNN: 0,
  VUV: 0,
  WST: 0,
  XAF: 61,
  XCD: 62,
  XEU: 0,
  XFO: 0,
  XFU: 0,
  XOF: 63,
  XPF: 90,
  XRE: 0,
  YDD: 0,
  YER: 0,
  YUD: 0,
  YUM: 0,
  YUN: 0,
  YUR: 0,
  ZAL: 0,
  ZAR: 64,
  ZMK: 0,
  ZMW: 0,
  ZRN: 0,
  ZRZ: 0,
  ZWD: 0,
  ZWL: 0,
  ZWR: 0,
} as const;

export type CurrencyCode = introspection_types['currencyCode']['enumValues'];

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const CURRENCIES = Object.keys(legacyCurrencyCodeMap) as CurrencyCode[];

export const currencyCodeSchema = z
  .string()
  .length(3)
  .toUpperCase()
  .refine(
    (c): c is CurrencyCode => {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      return CURRENCIES.includes(c as CurrencyCode);
    },
    { message: 'Invalid currency code' },
  );

export const currencySchema = z.object({
  code: currencyCodeSchema,
  name: z.string(),
  isTransactional: z.boolean(),
  exchangeRate: z.number(),
  isDefault: z.boolean(),
  display: z.object({
    symbol: z.string(),
    symbolPlacement: z.string(),
  }),
});

export type Currency = z.infer<typeof currencySchema>;
